import * as HLF from "html-living-framework";
import {Assembly} from "./Assembly";
import {MovieSlot, MovieSlots} from "./MovieModel";
import {array, Callback} from "../../Core/Reflection";
import {AssemblyBody, AssemblyItem} from "./AssemblyItem";
import {Ease} from "../../Core/Animatable";
import {MagicPoof} from "../MagicPoof";
import {Sprite} from "../../Core/Sprite";
import {Poly} from "../../Core/Shape";
import {AudioChannel} from "../../Core/AudioChannel";

export class Movie extends Assembly<MovieSlot> {

    readonly [MovieSlot.Background] = array(() => this.addChild(new AssemblyItem(MovieSlot.Background)));
    readonly [MovieSlot.Character] = array((i: number) => this.addChild(new AssemblyItem(MovieSlot.Character, i + 1)));
    readonly [MovieSlot.Prop] = array(() => this.addChild(new AssemblyItem(MovieSlot.Prop)));
    readonly [MovieSlot.Animal] = array(() => this.addChild(new AssemblyItem(MovieSlot.Animal)));
    readonly tvScreen = new Sprite();
    readonly tvMask: number[] = [];
    private _asTV = false;

    constructor() {
        super(MovieSlots);
    }

    asTV() {
        if (this._asTV) return;
        this._asTV = true;
        const mask = this.addChild(new Poly(this.tvMask));
        this.children.forEach(it => {
            if (it !== mask) it.mask = mask;
        });
        this.addChild(this.tvScreen);
    }

    protected getBodyItems(): AssemblyBody<MovieSlot>[] {
        return [];
    }

    protected getSlotItems(slot: MovieSlot): AssemblyItem<MovieSlot>[] {
        return this[slot];
    }

    setSlot(slot: MovieSlot, value?: number) {
        if (slot === MovieSlot.Animal) {
            this.getSlotItems(slot).forEach(it => it.visible = false);
        } else {
            super.setSlot(slot, value);
        }
    }

    showAnimal(cb?: Callback) {
        const animals = this.getSlotItems(MovieSlot.Animal);
        const animal = HLF.ArrayUtils.random(animals);
        const character = this.getSlotItems(MovieSlot.Character).filter(it => it.visible)[0];
        if (character) {
            AudioChannel.SFX.play("change-into");
            const s = character.scale.x;
            character.scaleTo(0, 0.3, Ease.sineIn, () => {
                character.scale.set(s);
                character.visible = false;
                const poof = this.addChild(new MagicPoof());
                poof.x = animal.x;
                poof.y = animal.y - animal.height * 0.5;
                animal.visible = true;
                animal.scaleFrom(0, 0.6, Ease.backOut, cb);
            });
        }
    }

    getRender(): string | undefined {
        this.asTV();
        return super.getRender();
    }

    getEditableSlots(): MovieSlot[] {
        return this.slots.filter(it => it !== MovieSlot.Animal);
    }
}